'use strict';
var breakpoints = require('../components/breakpoints');
$(function () {
    /**
    * Control the Check Balance form embedded in the Gift Card Landing page.
    *
    * Enter Card Number and PIN to check balance.
    */
    $('#CheckBalanceButton').on('click', function (e) {
        e.preventDefault();

        var $checkBalanceForm = $(this).closest('form');
        var actionURL = $checkBalanceForm.attr('action');
        var gcID = $('input[name=giftCertID]').val();
        var gcPin = $('input[name=giftCertPin]').val();
        var data = $checkBalanceForm.serialize();

        $('.checkBalanceError').hide();

        // Simple check for non-empty fields.
        var inputError = false;
        var errorMessage;
        if (gcID === '') {
            errorMessage = $checkBalanceForm.data('missing-card');
            $('.checkBalanceError').html(`<div class="text-danger mb-3">${errorMessage}</div>`).show();
            inputError = true;
        } else if (gcPin === '') {
            errorMessage = $checkBalanceForm.data('missing-pin');
            $('.checkBalanceError').html(`<div class="text-danger mb-3">${errorMessage}</div>`).show();
            inputError = true;
        }

        if (inputError === false) {
            $.ajax({
                url: actionURL,
                type: 'post',
                dataType: 'json',
                data: data,
                success: function (dataResponse) {
                    if (dataResponse.success === true) {
                        // Success
                        var responsePayload = JSON.parse(dataResponse.giftCertificate);
                        if (responsePayload && responsePayload.valid) {
                            var balanceMessage = responsePayload.amount;
                            var cardNumber = responsePayload.code;
                            $('.gc-balance-value').text(balanceMessage);
                            $('.gc-card-number').text(cardNumber);
                            $('.check-balance-success').removeClass('d-none');
                            $('.check-balance').hide();
                            $('.js-gc-balance-container .js-hide-on-success').hide();
                            if (breakpoints.isLowRes()) {
                                var totalHeightFromTop = $('.js-gc-balance-container').offset().top - $('.js-site-header').height() - 10; // subtracted 10 for space between header and balance container
                                $('html, body').animate({ scrollTop: totalHeightFromTop }, 300);
                            }
                        } else {
                            // Error
                            $('.checkBalanceError').html(`<div class="text-danger mb-3">${responsePayload.message}</div>`).show();
                        }
                        if ('dtmLayer' in dataResponse && 'digitalData' in window) {
                            if (dataResponse.dtmLayer.page && dataResponse.dtmLayer.page.form) {
                                window.digitalData.page.form = dataResponse.dtmLayer.page.form;
                            }

                            if (dataResponse.dtmLayer.user) {
                                window.digitalData.user = dataResponse.dtmLayer.user;
                            }

                            if (dataResponse.dtmLayer.cart) {
                                window.digitalData.cart = dataResponse.dtmLayer.cart;
                            }
                        }
                    } else {
                        if ('dtmLayer' in dataResponse && 'digitalData' in window) {
                            if (dataResponse.dtmLayer.page && dataResponse.dtmLayer.page.form) {
                                delete window.digitalData.page.form.giftCardNumber;
                                delete window.digitalData.page.form.giftCardBalance;
                            }
                        }
                        // Error
                        $('.checkBalanceError').html(`<div class="text-danger mb-3">${dataResponse.message}</div>`).show();
                    }
                },
                error: function (dataResponse) {
                    // Error
                    errorMessage = dataResponse.message;
                    if (errorMessage.length === 0) {
                        errorMessage = $checkBalanceForm.data('error-communication');
                    }
                    $('.checkBalanceError').html(`<div class="text-danger mb-3">${errorMessage}</div>`).show();
                }
            });
        }
    });

    // Check balance on a different card
    $('.check-another-balance').on('click', function (e) {
        e.preventDefault();

        $('input[name=giftCertID]').val('');
        $('input[name=giftCertPin]').val('');
        $('.check-balance-success').addClass('d-none');
        $('.checkBalanceError').hide();
        $('.check-balance').show();
        $('.js-gc-balance-container .js-hide-on-success').show();
    });

    $('.bulk-order .giftcard_link').on('click', function () {
        $('.card.gift-card-card').removeClass('d-none');
    });

    $('.bulk-order-close').on('click', function () {
        $('.card.gift-card-card').addClass('d-none');
    });
});
